module.exports = __webpack_public_path__ + "static/img/game_list01.60491c75.jpg";